import { apiClient } from '../api/apiClient';

export const dashboardService = {
    getEquipmentCount() {
        return apiClient.get('equipment/dashboard-count');
    }
};
